import { render, staticRenderFns } from "./PrizeTile.vue?vue&type=template&id=06e71e00&"
import script from "./PrizeTile.vue?vue&type=script&lang=js&"
export * from "./PrizeTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports